import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LogoutIcon } from 'assets/icons/error.svg';
import useRoleContext from 'contexts/role.context';

interface LogoutModalProps {
  show: boolean;
  onClose: () => void;
}

interface LogoutModalFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
}

const LogoutModalFooter: FC<LogoutModalFooterProps> = ({ onCancel, onConfirm }) => (
  <div className='flex gap-2'>
    <Button small color='gray' variant='block' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button small color='primary' variant='block' className='mx-auto' onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const LogoutModal: FC<LogoutModalProps> = ({ show, onClose }) => {
  const navigate = useNavigate();
  const { setRoleAuthorization, setIsMainAdmin } = useRoleContext();

  const confirmDelete = () => {
    localStorage.clear();
    setRoleAuthorization();
    setIsMainAdmin(false);
    navigate('/login');
  };

  return (
    <BaseModal
      isOpen={show}
      title=''
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={<LogoutModalFooter onCancel={() => onClose()} onConfirm={() => confirmDelete()} />}>
      <div className='flex flex-col justify-center items-center'>
        <LogoutIcon />
        <p className=' px- text-[30px] py-2'>Logout</p>

        <p className='text-sm text-gray-8 text-center'>Sure you want to leave?</p>
      </div>
    </BaseModal>
  );
};

export default LogoutModal;
